export default __webpack_public_path__ + "static/image-one-mobile-70643e4d58da16e6c89cf080555cf024.png";